import { Component } from "@angular/core";
import { IonicPage } from "ionic-angular";

@IonicPage({name: "root"})
@Component({
    selector: "page-root",
    template: ""
})
export class RootPage {

}



// WEBPACK FOOTER //
// ./src/vas/pages/root/root.ts